/* Koleksiyon kartlarinda hover'da video oynatir.

   card-product.liquid'e dokunmaz. Koleksiyon sablonundaki custom-liquid blogu
   #card-hover-video-data icinde { handle: {poster, srcs:[{u,h}]} } basar;
   bu script kartlari urun linkinden eslestirip <video> enjekte eder.

   Kart onizlemesi icin EN KUCUK mp4 secilir (genelde 480p ~0.9 Mbps).
   Kaynak ilk hover'a kadar atanmaz, boylece sayfa acilisi etkilenmez.
   Dokunmatik cihazda ve prefers-reduced-motion'da hic calismaz. */
(function () {
  if (window.__qutahiaCardHoverVideo) return;
  window.__qutahiaCardHoverVideo = true;

  function smallest(srcs) {
    if (!srcs || !srcs.length) return null;
    return srcs.slice().sort(function (a, b) { return (a.h || 0) - (b.h || 0); })[0].u;
  }

  function init() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var el = document.getElementById('card-hover-video-data');
    if (!el) return;

    var map;
    try { map = JSON.parse(el.textContent); } catch (e) { return; }

    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.hoverVideo) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;

      var data = map[m[1]];
      if (!data) return;
      var src = smallest(data.srcs);
      if (!src) return;

      var holder = card.querySelector('.media--hover-effect') || card.querySelector('.card__media .media');
      if (!holder) return;

      var v = document.createElement('video');
      v.className = 'card__hover-video';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.preload = 'none';
      v.tabIndex = -1;
      v.setAttribute('aria-hidden', 'true');
      if (data.poster) v.poster = data.poster;
      holder.appendChild(v);

      card.dataset.hoverVideo = '1';

      card.addEventListener('mouseenter', function () {
        if (!v.dataset.ready) { v.src = src; v.dataset.ready = '1'; }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });

      card.addEventListener('mouseleave', function () {
        v.pause();
        v.currentTime = 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () { init(); })
    .observe(document.body, { childList: true, subtree: true });
})();
